import { YoutubePlayer } from "@sorcery/ui";

export const EmbeddedVideo = ({ url }: { url: string }) => {
  return <YoutubePlayer url={url} />;
};
